import React from 'react';
// import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { MainView } from '../../templates/MainView';
import { Image } from '../../components/atoms/Image';
import { Heading } from '../../components/atoms/Heading';
import { Text } from '../../components/atoms/Text';
import { Button } from '../../components/atoms/Button';

import './styles.css';

import HelpBlockImage from '../../assets/images/conversation.png';
import { InfoCard } from '../../components/molecules/InfoCard';
import Illustration from '../../components/molecules/Illustration';
import { useSelector } from 'react-redux';

import Map from './Map';

/**
 * Primary UI component for user interaction
 */
function Landing() {
    const navigate = useNavigate();
    const data = JSON.parse(localStorage.getItem('data')) || {};

    // all answers should be no except for the last question
    const answers = {
        // accessibility:"yes",
        age:"yes",
        atrial:"no",
        cholesterol:"no",
        coronary:"no",
        cvd:"no",
        diabetes:"no",
        // dorset:"yes",
        gp:"yes",
        healthcheck:"no",
        heartfailure:"no",
        hypertension:"no",
        kidney:"no",
        pad:"no",
        statins:"no",
        stroke:"no",
        tia:"no",
    };

    // compare data to answers
    const isEligible = Object.keys(answers).every((key) => answers[key] === data[key]);

    console.log(data, answers, isEligible);

    return (
        <MainView type="fullwidth">
            <section className="w-full bg-gray-100 md:py-10">
                { isEligible ?
                <div
                    className={`bg-primary-100 mx-auto md:rounded-xl max-w-lwd-758 lg:w-1/2`}>
                    <div className="flex flex-col h-auto gap-5 md:rounded-xl">
                        <Illustration type="landing" classes="w-full object-center rounded-t-xl md:min-h-[106px]" />
                    </div>

                    <div className="flex flex-col gap-2 p-6 md:p-14">
                        <Heading h1>Great News! You are eligible.</Heading>
                        <Text body>
                            Please click an area of the map to see the available events.
                        </Text>

                        <Map />

                        <Text body>
                            If you’ve been unable to find an event near you, please suggest a location by filling out this <a href="https://form.jotform.com/250773370721354" target='_blank'>form</a>.
                        </Text>
                    </div>
                </div>
                :
                <div
                    className={`bg-primary-100 mx-auto md:rounded-xl max-w-lwd-758 lg:w-1/2`}>
                    <div className="flex flex-col h-auto gap-5 md:rounded-xl">
                        <Illustration type="landing" classes="w-full object-center rounded-t-xl md:min-h-[106px]" />
                    </div>

                    <div className="flex flex-col gap-2 p-6 md:p-14">
                        <Heading h1>Sorry, you are not eligible.</Heading>
                        <Text body>
                            We are sorry - you are not currently eligible for an NHS Health Check.
                            Please <a href="/">click here</a> for more information on looking after your health.
                        </Text>

                        {/* <Map /> */}

                    </div>
                </div>
                }
            </section>
        </MainView>
    );
}

export default Landing;
